export const formModel = {
	cpf: '',
};

export const validateModel = { cpf: '' };
